import { useAuth } from '../contexts/AuthenticationContext';
import { Header } from '../components/Header/Header';
import { CardInfo } from '../components/CardInfo/CardInfo';
import { CardHeader } from '../components/CardHeader/CardHeader';
import { CardBody } from '../components/CardBody/CardBody';
import {Col, Row, Container, Button, Spinner} from 'react-bootstrap';
import {useHistory} from "react-router-dom";
import Switch from "react-switch";
import {useEffect, useState} from "react";
import {alterarTopicos} from "../contexts/NotificationsContext";

type UserProps = {
	cdoc: string;
	cid: number;
	cname: string;
	ctopic: [[{
		conexoes: [];
		contratos: [];
		faturas: [];
		geral: [];
	}]];
	database: string;
	exp: number;
	iat: number;
	iss: number;
	uid: number;
	ulogin: string;
	uname: string;
}

type SessionProps = {
	token: string;
	notifications_invoices: boolean,
	notifications_contracts: boolean,
	notifications_connections: boolean,
	date_access: string;
	data: UserProps;
	exp: number;
	id_contract: string;
	numero_contrato: string;
}

export function Settings() {
	const history = useHistory();

	const { session, logOut, handleSetSession } = useAuth();

	const [loading, setLoading] = useState(false);
	const [checkedInvoices, setCheckedInvoices] = useState(false);
	const [checkedContracts, setCheckedContracts] = useState(false);
	const [checkedConnections, setCheckedConnections] = useState(false);
	const [storeLink, setStoreLink] = useState("");

	async function handleLogout() {
		logOut();
		history.push('/')
	}

	useEffect(() => {
		setStoreLink(getStoreLink());
	}, []);

	useEffect(() => {
		setLoading(true);
		if (session?.notifications_invoices) {
			setCheckedInvoices(true);
		}
		if (session?.notifications_contracts) {
			setCheckedContracts(true);
		}
		if (session?.notifications_connections) {
			setCheckedConnections(true);
		}
		setLoading(false);
	},[]);

	async function handleNotificationsInvoices() {
		if (session) {
			let topics = JSON.parse(localStorage.getItem('session_netcomet_topics_all') || '[]');

			if (topics) {
				if (checkedInvoices){
					let data: SessionProps;
					data = {
						token: session.token,
						notifications_invoices: false,
						notifications_contracts: session.notifications_contracts,
						notifications_connections: session.notifications_connections,
						date_access: session.date_access,
						data: session.data,
						exp: session.exp,
						id_contract: session.id_contract,
						numero_contrato:session.numero_contrato
					};
					localStorage.setItem('session', JSON.stringify(data));
					handleSetSession(data);
					setCheckedInvoices(false);

					if (localStorage.getItem('session_netcomet_token')) {
						alterarTopicos(session.token, false, localStorage.getItem('session_netcomet_token') || '', topics.faturas).catch((erro) => {
							console.log(erro)
						});
					}
				} else {
					if (localStorage.getItem('session_netcomet_token')) {
						alterarTopicos(session.token, true, localStorage.getItem('session_netcomet_token') || '', topics.faturas).catch((erro) => {
							console.log(erro)
						});
					}

					let data: SessionProps;
					data = {
						token: session.token,
						notifications_invoices: true,
						notifications_contracts: session.notifications_contracts,
						notifications_connections: session.notifications_connections,
						date_access: session.date_access,
						data: session.data,
						exp: session.exp,
						id_contract: session.id_contract,
						numero_contrato:session.numero_contrato
					};
					localStorage.setItem('session', JSON.stringify(data));
					handleSetSession(data);
					setCheckedInvoices(true);
				}
			}
		}
	}

	async function handleNotificationsConnection() {
		if (session) {
			let topics = JSON.parse(localStorage.getItem('session_netcomet_topics_all') || '[]');

			if (topics) {
				if (checkedConnections) {
					let data: SessionProps;
					data = {
						token: session.token,
						notifications_invoices: session.notifications_invoices,
						notifications_contracts: session.notifications_contracts,
						notifications_connections: false,
						date_access: session.date_access,
						data: session.data,
						exp: session.exp,
						id_contract: session.id_contract,
						numero_contrato: session.numero_contrato
					};
					localStorage.setItem('session', JSON.stringify(data));
					handleSetSession(data);
					setCheckedConnections(false);

					if (localStorage.getItem('session_netcomet_token')) {
						alterarTopicos(session.token, false, localStorage.getItem('session_netcomet_token') || '', topics.conexoes).catch((erro) => {
							console.log(erro)
						});
					}
				} else {
					if (localStorage.getItem('session_netcomet_token')) {
						alterarTopicos(session.token, true, localStorage.getItem('session_netcomet_token') || '', topics.conexoes).catch((erro) => {
							console.log(erro)
						});
					}

					let data: SessionProps;
					data = {
						token: session.token,
						notifications_invoices: session.notifications_invoices,
						notifications_contracts: session.notifications_contracts,
						notifications_connections: true,
						date_access: session.date_access,
						data: session.data,
						exp: session.exp,
						id_contract: session.id_contract,
						numero_contrato: session.numero_contrato
					};
					localStorage.setItem('session', JSON.stringify(data));
					handleSetSession(data);
					setCheckedConnections(true);
				}
			}
		}
	}

	async function handleNotificationsContract() {
		if (session) {
			let topics = JSON.parse(localStorage.getItem('session_netcomet_topics_all') || '[]');

			if (topics) {
				if (checkedContracts) {
					let data: SessionProps;
					data = {
						token: session.token,
						notifications_invoices: session.notifications_invoices,
						notifications_contracts: false,
						notifications_connections: session.notifications_connections,
						date_access: session.date_access,
						data: session.data,
						exp: session.exp,
						id_contract: session.id_contract,
						numero_contrato: session.numero_contrato
					};
					localStorage.setItem('session', JSON.stringify(data));
					handleSetSession(data);
					setCheckedContracts(false);

					if (localStorage.getItem('session_netcomet_token')) {
						alterarTopicos(session.token, false, localStorage.getItem('session_netcomet_token') || '', topics.contratos).catch((erro) => {
							console.log(erro)
						});
					}
				} else {
					if (localStorage.getItem('session_netcomet_token')) {
						alterarTopicos(session.token, true, localStorage.getItem('session_netcomet_token') || '', topics.contratos).catch((erro) => {
							console.log(erro)
						});
					}

					let data: SessionProps;
					data = {
						token: session.token,
						notifications_invoices: session.notifications_invoices,
						notifications_contracts: true,
						notifications_connections: session.notifications_connections,
						date_access: session.date_access,
						data: session.data,
						exp: session.exp,
						id_contract: session.id_contract,
						numero_contrato: session.numero_contrato
					};
					localStorage.setItem('session', JSON.stringify(data));
					handleSetSession(data);
					setCheckedContracts(true);
				}
			}
		}
	}

	function getStoreLink() {
		const userAgent = navigator.userAgent.toLowerCase();

		if (userAgent.includes("iPhone") || userAgent.includes("iPad") || userAgent.includes("mac")) {
			return "https://apps.apple.com/br/app/netcomet/id6739140081";
		} else {
			return "https://play.google.com/store/apps/details?id=br.com.netcomet.netcometanlise&hl=pt_BR&gl=US";
		}
	}

	return(
		<>
			<Header />
			<Container>
				<Row className="m-3">
					<Col md={6} className="d-flex p-0">
						<h3 className="title-page d-flex">
							<Button variant={""} className="d-flex shadow-none p-0" onClick={() => {history.goBack()}}>
								<span className="material-icons title-icon">keyboard_arrow_left</span>
							</Button>
							<span className="material-icons title-icon">settings</span>
							Configurações
						</h3>
					</Col>
				</Row>
				<Row>
					<Row className="m-card">
						<Col md={12} className="d-flex justify-content-center">
							<CardInfo variant="w-100">
								<CardHeader variant="text-center card-header-info">
									<div className="d-flex align-items-center">
										<span className="material-icons title-icon">settings</span>
										Configurações
									</div>
								</CardHeader>
								<CardBody>
									<Row className="d-flex m-0">
										{loading && <div className="justify-content-center align-items-center d-flex p-2">
											<Spinner animation="border" role="status"/>
										</div>
										}
										{!loading && <>
											<Col md={12} sm={12} xs={12}>
												<p className="mb-1">{session?.data.cname}</p>
												<p className="color-gray">Entrou em {session?.date_access}</p>
											</Col>
											<Col md={12} sm={12} xs={12}>
												<hr/>
											</Col>
											{(('Notification' in window) || ('serviceWorker' in navigator)) &&
												<>
													<Col md={8} sm={8} xs={8}>
														<p className="mb-1">Notificações de Faturas</p>
														<p className="color-gray">{checkedInvoices ? 'Ativado' : 'Desativado'}</p>
													</Col>
													<Col md={4} sm={4} xs={4} className="justify-content-center align-self-center text-center d-grid p-2">
														<Switch
															onChange={() => {handleNotificationsInvoices()}}
															checked={checkedInvoices}
															onColor={"#00B3E0"}
															uncheckedIcon={false}
															checkedIcon={false}
														/>
													</Col>
													<Col md={12} sm={12} xs={12}>
														<hr/>
													</Col>
													<Col md={8} sm={8} xs={8}>
														<p className="mb-1">Notificações de Conexões</p>
														<p className="color-gray">{checkedConnections ? 'Ativado' : 'Desativado'}</p>
													</Col>
													<Col md={4} sm={4} xs={4} className="justify-content-center align-self-center text-center d-grid p-2">
														<Switch
															onChange={() => {handleNotificationsConnection()}}
															checked={checkedConnections}
															onColor={"#00B3E0"}
															uncheckedIcon={false}
															checkedIcon={false}
														/>
													</Col>
													<Col md={12} sm={12} xs={12}>
														<hr/>
													</Col>
													<Col md={8} sm={8} xs={8}>
														<p className="mb-1">Notificações de Contratos</p>
														<p className="color-gray">{checkedContracts ? 'Ativado' : 'Desativado'}</p>
													</Col>
													<Col md={4} sm={4} xs={4} className="justify-content-center align-self-center text-center d-grid p-2">
														<Switch
															onChange={() => {handleNotificationsContract()}}
															checked={checkedContracts}
															onColor={"#00B3E0"}
															uncheckedIcon={false}
															checkedIcon={false}
														/>
													</Col>
													<Col md={12} sm={12} xs={12}>
														<hr/>
													</Col>
												</>}
											<Col md={8} sm={8} xs={8}>
												<p className="mb-1">Site da Netcomet</p>
												<p className="color-gray">Para mais informações acesse o site</p>
											</Col>
											<Col md={4} sm={4} xs={4} className="align-self-center text-center d-grid p-2">
												<Button variant="light" onClick={() => window.open("https://netcomet.com.br/", '_blank')}>Acessar</Button>
											</Col>
											<Col md={12} sm={12} xs={12}>
												<hr/>
											</Col>
											<Col md={8} sm={8} xs={8}>
												<p className="mb-1">Baixar Aplicativo</p>
												<p className="color-gray">Acesse o portal no seu smartphone</p>
											</Col>
											<Col md={4} sm={4} xs={4} className="align-self-center text-center d-grid p-2">
												<Button variant="light" onClick={() => window.open(storeLink, '_blank')}>Baixar</Button>
											</Col>

											<Col md={12} sm={12} xs={12}>
												<hr/>
											</Col>
											<Col md={8} sm={8} xs={8}>
												<p className="mb-1">Política de Privacidade</p>
												<p className="color-gray">Termos de Uso</p>
											</Col>
											<Col md={4} sm={4} xs={4} className="align-self-center text-center d-grid p-2">
												<Button variant="light" onClick={() => window.open("https://netcomet.com.br/politica_privacidade.php", '_blank')}>Acessar</Button>
											</Col>
											<Col md={12} sm={12} xs={12}>
												<hr/>
											</Col>
											<Col md={12} sm={12} xs={12}>
												<Button className="d-flex w-100 justify-content-center align-items-center mb-3" variant="light" onClick={() => handleLogout()}>
													Sair
												</Button>
											</Col>
										</>}
									</Row>
								</CardBody>
							</CardInfo>
						</Col>
					</Row>
				</Row>
			</Container>
		</>
	);
}
